import { render, staticRenderFns } from "./DRSTBoxItem.vue?vue&type=template&id=594e8af9&"
import script from "./DRSTBoxItem.vue?vue&type=script&lang=ts&"
export * from "./DRSTBoxItem.vue?vue&type=script&lang=ts&"
import style0 from "./DRSTBoxItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wannes.vermeulen/Repositories/dorst-app/dorst/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('594e8af9')) {
      api.createRecord('594e8af9', component.options)
    } else {
      api.reload('594e8af9', component.options)
    }
    module.hot.accept("./DRSTBoxItem.vue?vue&type=template&id=594e8af9&", function () {
      api.rerender('594e8af9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/src/DRSTBoxItem.vue"
export default component.exports